<ul class="filter-list clearfix" [id]="filterElement().id">
  @for (facet of filterElement().facets; track facet) {
  <li class="filter-item filter-color" [ngClass]="{ 'filter-selected': facet.selected }">
    <button
      type="button"
      class="filter-swatch btn btn-link btn-link-action"
      [title]="facet.displayName + ' (' + facet.count + ')'"
      (click)="filter(facet)"
      [attr.data-testing-id]="'filter-link-' + (facet.displayName | ishSanitize)"
      [attr.aria-current]="facet.selected ? 'true' : undefined"
    >
      <span
        [style.background-image]="getBackgroundImage(facet)"
        [style.background-color]="getBackgroundColor(facet)"
        [style.border]="facet.displayName.toLowerCase() === 'white' ? '1px solid #ddd' : null"
      ></span>
    </button>
  </li>
  }
</ul>
